<div class="where-wrapper" (outsideClick)="setFocus(false)">
  <div class="left" style="height: 20px">
    <svg-icon style="height: 20px" [svgStyle]="{'width.px': 20, 'height.px': 20}" src="/assets/icons/magnifying-glass-grey.svg"></svg-icon>
  </div>
  <div class="right">
    <div class="theme-input">
      <input #whereInput class="input where" [value]="displayValue" type="text" [placeholder]="(focused | async) ? '' : placeholderText" (focus)="setFocus(true)">
    </div>
  </div>
  <ng-container *ngIf="active && (focused | async) && (query | async)">
    <div class="search-overlay" (click)="setFocus(false)"></div>
    <div class="search-wrapper" [hidden]="!(showSearches | async) || !(query | async)">
      <div class="search-content">
        <div class="search-results">
          <div *ngFor="let place of places | async; trackBy: trackByCity" (click)="doUpdate(place)" class="search-result">
             <ng-container *ngIf="place.searchType === 1 || place.searchType === 4 || place.searchType === 5">
              <app-place [place]="place" [query]="whereInput.value"></app-place>
            </ng-container>
            <ng-container *ngIf="place.searchType === 2">
              <app-hostel [hostel]="place" [query]="whereInput.value"></app-hostel>
            </ng-container>
          </div>
          <div class="search-result noop" *ngIf="(places | async)?.length <= 0 && !(searching | async)">No results</div>
          <div class="search-result noop" *ngIf="(searching | async) && !(places | async)?.length">Searching places...</div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
